<template>
  <div class="c-information-index">
    <PageTitle titleText="お知らせ"></PageTitle>
    <router-link
      :to="{
        name: 'admin-information',
        params: { mc_code: currentUser.mansion._id },
      }"
    >
      <ButtonAdmin
        text="→お知らせ登録はこちら"
        width="18rem"
        v-if="isPermission('Admin')"
      ></ButtonAdmin>
    </router-link>
    <News />
  </div>
</template>

<script>
import News from "@/components/News.vue";
import PageTitle from "@/components/PageTitle.vue";
import ButtonAdmin from "@/components/ButtonAdmin.vue";
export default {
  components: { News, PageTitle, ButtonAdmin },
};
</script>

<style></style>
